import {CommonModule, CurrencyPipe} from '@angular/common';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

// ACABIM modules
import {AcabimAssetsModule} from '@cas-hub/acabim-assets-client';
import {AcabimBimVisualiserModule} from '@cas-hub/acabim-bim-visualiser-client';
import {AcabimAuthGuardService, AcabimCommonModule} from '@cas-hub/acabim-common-client';
import {AcabimQaModule} from '@cas-hub/acabim-qa-client';
import {OnboardingModule} from './_modules/onboarding/onboarding.module';

// PRIME NG
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {ButtonModule} from 'primeng/button';
import {CalendarModule} from 'primeng/calendar';
import {CardModule} from 'primeng/card';
import {CarouselModule} from 'primeng/carousel';
import {CheckboxModule} from 'primeng/checkbox';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DialogModule} from 'primeng/dialog';
import {DialogService, DynamicDialogModule} from 'primeng/dynamicdialog';
import {DropdownModule} from 'primeng/dropdown';
import {FieldsetModule} from 'primeng/fieldset';
import {FileUploadModule} from 'primeng/fileupload';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {MessageModule} from 'primeng/message';
import {MessageService} from 'primeng/api';
import {MessagesModule} from 'primeng/messages';
import {MultiSelectModule} from 'primeng/multiselect';
import {PanelModule} from 'primeng/panel';
import {PickListModule} from 'primeng/picklist';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {RadioButtonModule} from 'primeng/radiobutton';
import {RippleModule} from 'primeng/ripple';
import {TabViewModule} from 'primeng/tabview';
import {TableModule} from 'primeng/table';
import {ToastModule} from 'primeng/toast';
import {ToolbarModule} from 'primeng/toolbar';
import {TooltipModule} from 'primeng/tooltip';
import {TreeSelectModule} from 'primeng/treeselect';

// ACABIM
// import {AddContactModalComponent} from './pages/contact/add-contact-modal/add-contact-modal.component';
// import {AddDataComponent} from './pages/contact/add-contact-modal/add-data-modal/add-data.component';
// import {DeleteDataComponent} from './pages/contact/add-contact-modal/delete-data-modal/delete-data.component';
import {ACAAdminCapConfigComponent} from './pages/settings/cap-config/cap-config.component';
import {ACAAdminSettingsComponent} from './pages/settings/settings.component';
import {ACAAdminSiteConfigComponent} from './pages/settings/site-config/site-config.component';
import {AcabimAdminLayoutComponent} from './acabim-admin-layout.component';
import {ActionArchiveComponent } from './pages/actions/action-archive/action-archive.component';
import {ActionDetailComponent } from './pages/actions/action-detail/action-detail.component';
import {ActionsComponent } from './pages/actions/actions.component';
import {AddAssetGroupComponent} from './pages/assets/asset-group/add-asset-group/add-asset-group.component';
import {AddAssetTypeClassificationComponent} from './pages/assets/asset-type/asset-type-classification/add-asset-type-classification/add-asset-type-classification.component';
import {AddAssetTypeComponent} from './pages/assets/asset-type/add-asset-type/add-asset-type.component';
import {AddContactComponent} from './_components/contact/add-contact/add-contact.component';
import {AddEmailComponent} from './_components/contact/add-contact/add-email/add-email.component';
import {AddFunctionalPropertiesComponent} from './pages/bim/building-management/add-functional-properties/add-functional-properties.component';
import {AddInventoryComponent} from './pages/financial/financial-inventory/add-inventory/add-inventory.component';
import {AddOrganisationSeatComponent} from './pages/organisation/organisation-seats/add-organisation-seat/add-organisation-seat.component';
import {AddSiteComponent} from './pages/site-and-project/add-site/add-site.component';
import {AdminAuthGuardService} from './_services/auth/admin-auth-guard.service';
import {AdvancedComponent} from './pages/financial/financial-tables/financial-datatable/advanced/advanced.component';
import {ArchivedProjectsComponent} from './pages/site-and-project/site-details/archived-projects/archived-projects.component';
import {ArchivedSitesComponent} from './pages/site-and-project/archived-sites/archived-sites.component';
import {AssetGroupComponent} from './pages/assets/asset-group/asset-group.component';
import {AssetManagementComponent} from './pages/bim/asset-management/asset-management.component';
import {AssetTypeClassificationComponent} from './pages/assets/asset-type/asset-type-classification/asset-type-classification.component';
import {AssetTypeComponent} from './pages/assets/asset-type/asset-type.component';
import {AssignProjectGroupsComponent } from './_components/groups/assign-project-groups/assign-project-groups.component';
import {AssignSiteGroupsComponent } from './_components/groups/assign-site-groups/assign-site-groups.component';
import {BimComponent} from './pages/bim/bim.component';
import {BuildingFinancialManagementComponent} from './pages/bim/building-management/building-financial-management/building-financial-management.component';
import {BuildingManagementComponent} from './pages/bim/building-management/building-management.component';
import {ConfirmDeleteModalComponent} from './pages/contact/confirm-delete-modal/confirm-delete-modal.component';
import {ContactComponent} from './pages/contact/contact.component';
import {ContactDetailComponent} from './pages/contact/contact-detail/contact-detail.component';
import {ContactTypeAddComponent} from './pages/contact/contact-types/add-contact-type/add-contact-type.component';
import {ContactTypeUpdateComponent} from './pages/contact/contact-types/update-contact-type/update-contact-type.component';
import {ContactTypesComponent} from './pages/contact/contact-types/contact-type.component';
import {CreateBimModelComponent} from './pages/bim/manage-bim-models/create-bim-model/create-bim-model.component';
import {CreateExportRequestComponent} from './pages/bim/data-export/create-export-request/create-export-request.component';
import {CreateProjectComponent} from './pages/site-and-project/create-project/create-project.component';
import {DashboardComponent} from './pages/dashboard/dashboard.component';
import {DashboardProjectsComponent} from './pages/dashboard/dashboard-projects/dashboard-projects.component';
import {DataExportComponent} from './pages/bim/data-export/data-export.component';
import {DeleteFunctionalPropertiesComponent} from './pages/bim/building-management/delete-functional-properties/delete-functional-properties.component';
import {EditAccountComponent} from './pages/financial/financial-tables/financial-datatable/edit-account/edit-account.component';
import {EditClassComponent} from './pages/financial/manage-classes/edit-class/edit-class.component';
import {EditDetailsComponent} from './pages/longterm-maintenance/manage-budget-details/edit-details/edit-details.component';
import {EditOrganisationUserComponent} from './pages/organisation/organisation-users/edit-organisation-user/edit-organisation-user.component';
import {EditProjectComponent} from './pages/site-and-project/edit-project/edit-project.component';
import {EditSiteAddressComponent} from './pages/site-and-project/site-details/edit-site-address/edit-site-address.component';
import {EditSiteComponent} from './pages/site-and-project/site-details/edit-site.component';
import {EditTypeComponent} from './pages/financial/maintenance-types/edit-type/edit-type.component';
import {FinancialDatatableComponent} from './pages/financial/financial-tables/financial-datatable/financial-datatable.component';
import {FinancialDetailsComponent} from './pages/financial/financial-tables/financial-datatable/financial-details/financial-details.component';
import {FinancialInventoryComponent} from './pages/financial/financial-inventory/financial-inventory.component';
import {FinancialSettingsComponent} from './pages/financial/financial-settings/financial-settings.component';
import {FinancialTablesComponent} from './pages/financial/financial-tables/financial-tables.component';
import {FundTableComponent} from './pages/financial/financial-tables/financial-datatable/fund-table/fund-table.component';
import {GroupProjectAddComponent} from './pages/site-and-project/groups/groups-projects/add-project-group/add-project-group.component';
import {GroupProjectComponent} from './pages/site-and-project/groups/groups-projects/groups-projects.component';
import {GroupProjectUpdateComponent} from './pages/site-and-project/groups/groups-projects/update-project-group/update-project-group.component';
import {GroupSiteAddComponent} from './pages/site-and-project/groups/groups-sites/add-site-group/add-site-group.component';
import {GroupSiteComponent} from './pages/site-and-project/groups/groups-sites/groups-sites.component';
import {GroupSiteUpdateComponent} from './pages/site-and-project/groups/groups-sites/update-site-group/update-site-group.component';
import {GroupsComponent} from './pages/site-and-project/groups/groups.component';
import {ImportContactsComponent} from './pages/contact/import-contacts/import-contacts.component';
import {ImportUsersComponent} from './pages/contact/import-users/import-users.component';
import {LkmConfigComponent} from './pages/settings/lkm-config/lkm-config.component';
import {MaintenanceTypesComponent} from './pages/financial/maintenance-types/maintenance-types.component';
import {ManageBimModelsComponent} from './pages/bim/manage-bim-models/manage-bim-models.component';
import {ManageBudgetDetailsComponent} from './pages/longterm-maintenance/manage-budget-details/manage-budget-details.component';
import {ManageClassesComponent} from './pages/financial/manage-classes/manage-classes.component';
import {ManageLTMItemsComponent} from './pages/longterm-maintenance/manage-ltm-items.component';
import {MoveProjectComponent} from './pages/site-and-project/move-project/move-project.component';
import {OrganisationComponent} from './pages/organisation/organisation.component';
import {OrganisationPendingUsersComponent} from './pages/organisation/organisation-pending-users/organisation-pending-users.component';
import {OrganisationPreferencesComponent } from './pages/organisation/organisation-preferences/organisation-preferences.component';
import {OrganisationSeatsComponent} from './pages/organisation/organisation-seats/organisation-seats.component';
import {OrganisationUsersComponent} from './pages/organisation/organisation-users/organisation-users.component';
import {OrganisationsPickerComponent} from './pages/super/subscriptions/organisations-picker/organisations-picker.component';
import {PricingComponent} from './pages/super/subscriptions/pricing/pricing.component';
import {ProjectBuildingStatusComponent} from './pages/dashboard/project-building-status/project-building-status.component';
import {ProjectCapComponent} from './pages/project-cap/project-cap.component';
import {ProjectDetailsComponent} from './pages/dashboard/dashboard-projects/project-details/project-details.component';
import {ProjectsComponent} from './pages/site-and-project/site-details/projects/projects.component';
import {ResourceSubscriptionsViewComponent} from './pages/super/subscriptions/resource-subscriptions-view/resource-subscriptions-view.component';
import {SiteComponent} from './pages/site-and-project/site.component';
import {SiteListComponent} from './pages/site-and-project/site-list/site-list.component';
import {SiteRelatedStatsComponent} from './pages/dashboard/site-related-stats/site-related-stats.component';
import {SpaceGroupingComponent} from './pages/bim/space-grouping/space-grouping.component';
import {SpaceManagementComponent} from './pages/bim/space-management/space-management.component';
import {SubscriptionRequestComponent} from './pages/super/subscriptions/subscription-request/subscription-request.component';
import {SubscriptionsManagerComponent} from './pages/super/subscriptions/subscriptions-manager.component';
import {TasksComponent } from './pages/super/tasks/tasks.component';
import {ThirdPartyComponent} from './pages/financial/financial-tables/financial-datatable/third-party/third-party.component';
import {TransferProjectPhaseComponent} from './pages/site-and-project/edit-project/transfer-project-phase/transfer-project-phase.component';
import {UpdateAssetGroupComponent} from './pages/assets/asset-group/update-asset-group/update-asset-group.component';
import {UpdateAssetTypeClassificationComponent} from './pages/assets/asset-type/asset-type-classification/update-asset-type-classification/update-asset-type-classification.component';
import {UpdateAssetTypeComponent} from './pages/assets/asset-type/update-asset-type/update-asset-type.component';
import {UpdateBimModelComponent} from './pages/bim/manage-bim-models/update-bim-model/update-bim-model.component';
import {UserPropertySetsComponent} from './pages/bim/user-property-sets/user-property-sets.component';
import {UserSubscriptionsViewComponent} from './pages/super/subscriptions/user-subscriptions-view/user-subscriptions-view.component';
import {UserTypeStatsComponent} from './pages/dashboard/user-type-stats/user-type-stats.component';
import {ViewBimModelsComponent} from './pages/bim/manage-bim-models/view-bim-models/view-bim-models.component';
import {ViewExportRequestsComponent} from './pages/bim/data-export/view-export-requests/view-export-requests.component';
import {WorkOrderCategoryDetailsComponent} from './pages/work-order/work-order-category-management/work-order-category-details/work-order-category-details.component';
import {WorkOrderCategoryManagementComponent} from './pages/work-order/work-order-category-management/work-order-category-management.component';
import {WorkOrderSubcategoryDetailsComponent} from './pages/work-order/work-order-subcategory-management/work-order-subcategory-details/work-order-subcategory-details.component';
import {WorkOrderSubcategoryManagementComponent} from './pages/work-order/work-order-subcategory-management/work-order-subcategory-management.component';
import {WorkOrderTypeDetailsComponent} from './pages/work-order/work-order-type-management/work-order-type-details/work-order-type-details.component';
import {WorkOrderTypeManagementComponent} from './pages/work-order/work-order-type-management/work-order-type-management.component';
import { RemoveContactTypeComponent } from './pages/contact/contact-types/remove-contact-type/remove-contact-type.component';
import { DocumentUsageTypeManagementComponent } from './pages/document/document-usage-type-management/document-usage-type-management.component';

@NgModule({
    declarations: [
        // AddContactModalComponent,
        // AddDataComponent,
        // DeleteDataComponent,
        ACAAdminCapConfigComponent,
        ACAAdminSettingsComponent,
        ACAAdminSiteConfigComponent,
        AcabimAdminLayoutComponent,
        ActionArchiveComponent,
        ActionDetailComponent,
        ActionsComponent,
        AddAssetGroupComponent,
        AddAssetTypeClassificationComponent,
        AddAssetTypeComponent,
        AddContactComponent,
        AddEmailComponent,
        AddFunctionalPropertiesComponent,
        AddInventoryComponent,
        AddOrganisationSeatComponent,
        AddSiteComponent,
        AdvancedComponent,
        ArchivedProjectsComponent,
        ArchivedSitesComponent,
        AssetGroupComponent,
        AssetManagementComponent,
        AssetTypeClassificationComponent,
        AssetTypeComponent,
        AssignProjectGroupsComponent,
        AssignSiteGroupsComponent,
        BimComponent,
        BuildingFinancialManagementComponent,
        BuildingManagementComponent,
        ConfirmDeleteModalComponent,
        ContactComponent,
        ContactDetailComponent,
        ContactTypeAddComponent,
        ContactTypeUpdateComponent,
        ContactTypesComponent,
        CreateBimModelComponent,
        CreateExportRequestComponent,
        CreateProjectComponent,
        DashboardComponent,
        DashboardProjectsComponent,
        DataExportComponent,
        DeleteFunctionalPropertiesComponent,
        EditAccountComponent,
        EditClassComponent,
        EditDetailsComponent,
        EditOrganisationUserComponent,
        EditProjectComponent,
        EditSiteAddressComponent,
        EditSiteComponent,
        EditTypeComponent,
        FinancialDatatableComponent,
        FinancialDetailsComponent,
        FinancialInventoryComponent,
        FinancialSettingsComponent,
        FinancialTablesComponent,
        FundTableComponent,
        GroupProjectAddComponent,
        GroupProjectComponent,
        GroupProjectUpdateComponent,
        GroupSiteAddComponent,
        GroupSiteComponent,
        GroupSiteUpdateComponent,
        GroupsComponent,
        ImportContactsComponent,
        ImportUsersComponent,
        LkmConfigComponent,
        MaintenanceTypesComponent,
        ManageBimModelsComponent,
        ManageBudgetDetailsComponent,
        ManageClassesComponent,
        ManageLTMItemsComponent,
        MoveProjectComponent,
        OrganisationComponent,
        OrganisationPendingUsersComponent,
        OrganisationPreferencesComponent,
        OrganisationSeatsComponent,
        OrganisationUsersComponent,
        OrganisationsPickerComponent,
        PricingComponent,
        ProjectBuildingStatusComponent,
        ProjectCapComponent,
        ProjectDetailsComponent,
        ProjectsComponent,
        ResourceSubscriptionsViewComponent,
        SiteComponent,
        SiteListComponent,
        SiteRelatedStatsComponent,
        SpaceGroupingComponent,
        SpaceManagementComponent,
        SubscriptionRequestComponent,
        SubscriptionsManagerComponent,
        TasksComponent,
        ThirdPartyComponent,
        TransferProjectPhaseComponent,
        UpdateAssetGroupComponent,
        UpdateAssetTypeClassificationComponent,
        UpdateAssetTypeComponent,
        UpdateBimModelComponent,
        UserPropertySetsComponent,
        UserSubscriptionsViewComponent,
        UserTypeStatsComponent,
        ViewBimModelsComponent,
        ViewExportRequestsComponent,
        WorkOrderCategoryDetailsComponent,
        WorkOrderCategoryManagementComponent,
        WorkOrderSubcategoryDetailsComponent,
        WorkOrderSubcategoryManagementComponent,
        WorkOrderTypeDetailsComponent,
        WorkOrderTypeManagementComponent,
        RemoveContactTypeComponent,
        DocumentUsageTypeManagementComponent,
    ],
    imports: [
        AcabimAssetsModule,
        AcabimBimVisualiserModule,
        AcabimCommonModule,
        AcabimQaModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CardModule,
        CarouselModule,
        CheckboxModule,
        CommonModule,
        ConfirmDialogModule,
        DialogModule,
        DragDropModule,
        DropdownModule,
        DynamicDialogModule,
        FieldsetModule,
        FileUploadModule,
        FontAwesomeModule,
        FormsModule,
        InputNumberModule,
        InputTextModule,
        InputTextareaModule,
        MessageModule,
        MessagesModule,
        MultiSelectModule,
        MultiSelectModule,
        OnboardingModule,
        PanelModule,
        PickListModule,
        ProgressSpinnerModule,
        RadioButtonModule,
        ReactiveFormsModule,
        RippleModule,
        TabViewModule,
        TableModule,
        ToastModule,
        ToolbarModule,
        TooltipModule,
        TreeSelectModule,
        RouterModule.forChild([
            {
                path: '', canActivate: [AcabimAuthGuardService, AdminAuthGuardService], component: AcabimAdminLayoutComponent, children: [
                    {path: '', redirectTo: 'home', pathMatch: 'full'},
                    {path: 'home', component: DashboardComponent},
                    {path: 'actions', component: ActionsComponent},
                    {path: 'assets', component: AssetManagementComponent},
                    {path: 'assets/asset-groups', component: AssetGroupComponent},
                    {path: 'assets/long-term-maintenance-items', component: ManageLTMItemsComponent},
                    {path: 'assets/maintenance-types', component: MaintenanceTypesComponent},
                    {path: 'bim/bim-model-management', component: ManageBimModelsComponent},
                    {path: 'bim/building-management', component: BuildingManagementComponent},
                    {path: 'bim/data-export', component: DataExportComponent},
                    {path: 'bim/space-management', component: SpaceManagementComponent},
                    {path: 'bim/space-management/space-grouping', component: SpaceGroupingComponent},
                    {path: 'bim/user-property-sets', component: UserPropertySetsComponent},
                    {path: 'building-management', component: BuildingManagementComponent},
                    {path: 'cap/cap-in-project', component: ProjectCapComponent},
                    {path: 'cap/library', component: ACAAdminCapConfigComponent},
                    {path: 'cap/lkm', component: LkmConfigComponent},
                    {path: 'contacts', component: ContactComponent},
                    {path: 'contacts/types', component: ContactTypesComponent},
                    {path: 'document/document-types', component: DocumentUsageTypeManagementComponent},
                    {path: 'financial/accounts', component: FinancialTablesComponent},
                    {path: 'financial/inventory', component: FinancialInventoryComponent},
                    {path: 'financial/manage-account-classes', component: ManageClassesComponent},
                    {path: 'financial/settings', component: FinancialSettingsComponent},
                    {path: 'organisation', component: OrganisationComponent},
                    {path: 'organisation/preferences', component: OrganisationPreferencesComponent},
                    {path: 'sites-projects', component: ACAAdminSiteConfigComponent},
                    {path: 'sites-projects/groups', component: GroupsComponent},
                    {path: 'space-grouping', component: SpaceGroupingComponent},
                    {path: 'space-management', component: SpaceManagementComponent},
                    {path: 'subscriptions', component: SubscriptionsManagerComponent},
                    {path: 'subscriptions/pricing', component: PricingComponent},
                    {path: 'tasks', component: TasksComponent},
                    {path: 'work/work-types', component: WorkOrderTypeManagementComponent},
                ]
            }
        ])
    ],
    exports: [SiteRelatedStatsComponent, ProjectBuildingStatusComponent],
    providers: [DialogService, MessageService, CurrencyPipe],
    bootstrap: [AcabimAdminLayoutComponent]
})

export class AcabimAdminModule {}
